import { DateRangeType } from '../../../../components/DateRangePicker'
import { FromTo, ValueAndSetValue } from '../../../../components/Filters/types'
import { Product } from '../../storage'

export enum ComponentFilters {
  DATE = 'Date',
  PRICE = 'Price',
  SEARCH_PAST = 'SEARCH_PAST',
  SEARCH_TYPESENSE = 'SEARCH_TYPESENSE',
  CATEGORY = 'CATEGORY',
  IN_STOCK = 'IN_STOCK_CHECKBOX',
}
export interface ProductFilterProps {
  filters: {
    categories: string[]
  }
  selectedFilters: SelectedFiltersType
  items: Product[]
  components: ComponentFilters[]
}

export type ProductFilters = {
  category: string
  searchText: string
  dateRange: DateRangeType
  priceRange: FromTo<number>
}

export type SelectedFiltersType = ValueAndSetValue<{
  category: string
  // Value of the typed field only after a Submit action (i.e 'Enter')
  searchText: string
  // Text as it is typed into the field
  searchInput: string
  dateRange: DateRangeType
  priceRange: FromTo<number>
  inStock: boolean
  seedType?: string
  storeId: string | undefined
}>
